import colors from "_variables";

import Translate from "utils/translate";

const { t } = new Translate("Calendar");

export default [
  {
    type: "viewing",
    color: colors.$grayDarker,
    title: t("viewing"),
    url: ({ dealId }) => `/deals/${dealId}`,
  },
  {
    type: "call",
    color: colors.$gray,
    title: t("call"),
    url: ({ dealId }) => `/deals/${dealId}`,
  },
  {
    type: "due_proposal",
    color: colors.$blueLight,
    title: t("due_proposal"),
    url: ({ dealId }) => `/deals/${dealId}`,
  },
  {
    type: "lease_expiration",
    color: colors.$red,
    title: t("lease_expiration"),
    url: ({ dealId }) => `/deals/${dealId}`,
  },
  {
    type: "lease_start",
    color: colors.$green,
    title: t("lease_start"),
    url: ({ dealId }) => `/deals/${dealId}`,
  },
  {
    type: "space_available",
    color: colors.$darkGreen,
    title: t("space_available"),
    url: ({ assetId, portfolioId }) => `/assets?portfolioIDs[]=${portfolioId}&asset_id=${assetId}`,
  },
];
